module.exports = __webpack_public_path__ + "img/couples-080.27c51362.jpg";